import React from "react";
import { useTranslation } from "react-i18next";
import ContactForm from "../ContactFrom/ContactForm";
import MapLocation from "../mapsLocation/MapLocation";

const Contactpage = () => {
  const { t } = useTranslation("contact");
  return (
    <section className="wpo-contact-pg-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col col-lg-10 offset-lg-1">
            <div className="office-info">
              <div className="row">
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="office-info-item">
                    <div className="office-info-icon">
                      <div className="icon">
                        <i className="fi flaticon-placeholder"></i>
                      </div>
                    </div>
                    <div className="office-info-text">
                      <h2>{t("address")}</h2>
                      <p> ج3 حي يعقوب المنصور</p>
                      <p>J3 c.y.m</p>
                      <p>Rabat 10130</p>
                    </div>
                  </div>
                </div>
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="office-info-item">
                    <div className="office-info-icon">
                      <div className="icon">
                        <i className="fi flaticon-email"></i>
                      </div>
                    </div>
                    <div className="office-info-text">
                      <h2>{t("email")}</h2>
                      <p>DarMhamedAttaoui@gmail.com</p>
                    </div>
                  </div>
                </div>
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="office-info-item">
                    <div className="office-info-icon">
                      <div className="icon">
                        <i className="fi flaticon-phone-call"></i>
                      </div>
                    </div>
                    <div className="office-info-text">
                      <h2>{t("phone")}</h2>
                      <p dir="ltr">
                        <a href="tel:+212658152486">+212 658 152 486</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="wpo-contact-title">
              <h2>{t("haveQuestion")}</h2>
              <p>{t("leaveMessage")}</p>
            </div>
            <div className="wpo-contact-form-area">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
      <MapLocation />
    </section>
  );
};

export default Contactpage;
